// @ts-check
import { route } from './author.js';
export const RENDER_LEVELS = [
  route(5, 1, 'Wire to Solid', 'Outlined geometry is a preview. Strike its node to make it solid.', 146)
    .node(9, 3, 'upgrade', 'mesh').device('phase', 17, 1, 4, 0.5, 4, { group: 'mesh', alternate: true })
    .device('phase', 25, 3, 4, 0.5, 4, { group: 'mesh', alternate: true }).node(31, 5, 'overclock')
    .bot(37).checkpoint(46, 'Raster anchor').node(52, 3, 'bit', 'bridge')
    .gap(60, 7).device('phase', 60, 0, 7, 0.5, 4, { group: 'bridge' })
    .platform(74, 2, 4, 0.5).node(81).bot(89, 0, true).checkpoint(97, 'Assembly desk')
    .node(104, 3, 'bit', 'upper').device('phase', 112, 2, 4, 0.5, 4, { group: 'upper' })
    .device('phase', 119, 4, 4, 0.5, 4, { group: 'upper', alternate: true }).gap(127, 3).bot(136).build(),
  route(5, 2, 'Layer Two', 'Two layers share one space. Change them from the permanent anchors.', 158)
    .node(9, 3, 'upgrade', 'a').device('phase', 17, 2, 4, 0.5, 4, { group: 'a' })
    .device('phase', 24, 4, 4, 0.5, 4, { group: 'a', alternate: true }).platform(32, 2, 4, 0.5)
    .node(34, 4, 'bit', 'a').checkpoint(45, 'Layer anchor').node(51, 3, 'bit', 'b')
    .device('phase', 59, 1, 4, 0.5, 4, { group: 'b' }).device('phase', 66, 3, 4, 0.5, 4, { group: 'b', alternate: true })
    .device('phase', 73, 5, 4, 0.5, 4, { group: 'b' }).node(78, 7, 'overclock').bot(85)
    .checkpoint(94, 'Composite anchor').node(100, 3, 'upgrade', 'c').gap(108, 6)
    .device('phase', 108, 0, 6, 0.5, 4, { group: 'c' }).platform(121, 2, 4, 0.5)
    .device('phase', 129, 4, 4, 0.5, 4, { group: 'c', alternate: true }).bot(142, 0, true).build(),
  route(5, 3, 'Frame Assembly', 'A rising scan assembles the route. Use the stable frame edges between passes.', 164)
    .node(9).device('gate', 18, 1, 4, 0.5, 6).device('gate', 26, 3, 4, 0.5, 6, { offset: 1 })
    .device('gate', 34, 4, 4, 0.5, 6, { offset: 2 }).node(39, 6, 'overclock')
    .checkpoint(48, 'Frame buffer').node(55, 3, 'bit', 'frame').gap(62, 8)
    .device('phase', 62, 0, 8, 0.5, 4, { group: 'frame' }).node(76, 3, 'bit', 'frame')
    .device('scanner', 82, 0, 8, 0.6, 5).platform(88, 0, 1, 1).checkpoint(97, 'Compositor')
    .node(103).device('gate', 111, 2, 4, 0.5, 6).device('gate', 119, 4, 4, 0.5, 6, { offset: 1.5 })
    .device('gate', 128, 5, 4, 0.5, 6, { offset: 3 }).node(132, 7, 'overclock').gap(140, 3).bot(150).build(),
  route(5, 4, 'Render Target', 'The physical emitter has a cable. Use the layer node to expose it.', 110)
    .node(9, 3, 'upgrade', 'frame').device('phase', 17, 2, 4, 0.5, 4, { group: 'frame' })
    .device('phase', 25, 4, 4, 0.5, 4, { group: 'frame', alternate: true }).node(31, 6, 'bit', 'frame')
    .device('scanner', 40, 0, 10, 0.6, 5).platform(47, 0, 1, 1).node(56).bot(63)
    .boss('raster', 'Raster').build(),
];
